
import {
  features,
  usages,
  stats,
  popularServices,
  questions,
} from "~/data/siem";
import Os from "~/components/siem/os.vue";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  components: {
    Os,
    Modal,
  },
  data() {
    return {
      title: "سامانه SIEM آبالون | پایش، تحلیل و کشف تهدیدات پیچیده",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      activeSection: "",
      features,
      usages,
      stats,
      popularServices,
      questions,
    };
  },
  head() {
    return {
      title: "سامانه SIEM آبالون | پایش، تحلیل و کشف تهدیدات پیچیده",
      meta: [
        {
          name: "description",
          content:
            "SIEM بومی آبالون | مدیریت و تحلیل رخداد‌های امنیتی | شناسایی تهدیدها پیش از وقوع | قابل استقرار بر زیرساخت داخلی یا دیتاسنتر ابری امن  آبالون",
        },
        {
          name: "keywords",
          content:
            "سامانه SIEM آبالون, SIEM بومی, مدیریت اطلاعات و رویدادهای امنیتی",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/siem",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "سامانه SIEM آبالون | پایش، تحلیل و کشف تهدیدات پیچیده",
        },
        {
          property: "og:description",
          content:
            "SIEM بومی آبالون | مدیریت و تحلیل رخداد‌های امنیتی | شناسایی تهدیدها پیش از وقوع | قابل استقرار بر زیرساخت داخلی یا دیتاسنتر ابری امن  آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/siem",
        },
        {
          name: "twitter:title",
          title: "سامانه SIEM آبالون | پایش، تحلیل و کشف تهدیدات پیچیده",
        },
        {
          name: "twitter:description",
          content:
            "SIEM بومی آبالون | مدیریت و تحلیل رخداد‌های امنیتی | شناسایی تهدیدها پیش از وقوع | قابل استقرار بر زیرساخت داخلی یا دیتاسنتر ابری امن  آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/siem",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "سامانه SIEM آبالون چگونه به ارتقای امنیت سازمان کمک می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با گردآوری و تحلیل آنی داده‌های امنیتی از تمام بخش‌های زیرساخت، شناسایی تهدیدات پیش از وقوع و ارائه گزارش‌های دقیق به تیم SOC، سامانه SIEM آبالون نقش کلیدی در پیشگیری، کشف و پاسخ سریع به حوادث امنیتی ایفا می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "استفاده از هوش مصنوعی و یادگیری ماشینی در SIEM چه مزیتی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "زیرساخت تحلیلی SIEM آبالون با بهره‌گیری از هوش مصنوعی، تصمیم‌گیری‌های دقیق‌تر و سریع‌تر را برای تیم امنیتی ممکن می‌سازد. الگوریتم‌های یادگیری ماشینی نیز با تحلیل مداوم داده‌های جدید، می‌توانند الگوهای رفتاری و تهدیدات نوظهور را شناسایی کرده و خود را با آن‌ها تطبیق دهند. این ترکیب باعث کاهش بار عملیاتی، افزایش دقت تحلیل‌ها و واکنش مؤثرتر در برابر تهدیدات می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "SIEM آبالون چگونه در شناسایی و مدیریت تهدیدات مستمر پیشرفته (APT) و حملات چندمرحله‌ای عمل می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با ترکیب تحلیل رفتاری، تجمیع رویدادها و الگوریتم‌های هوش مصنوعی، سامانه SIEM آبالون می‌تواند زنجیره فعالیت‌های مشکوک را شناسایی و مسیر حمله را بازسازی کند تا پیش از بروز خسارت، واکنش مناسب انجام شود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان اتصال سامانه SIEM آبالون به سایر سامانه‌های امنیتی وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. SIEM ایرانی آبالون از استانداردهای یکپارچه‌سازی پشتیبانی می‌کند و می‌تواند با راهکارهایی مانند SOC ،SOAR و سیستم‌های تشخیص نفوذ (IDS/IPS) تبادل داده داشته باشد تا زنجیره دفاعی سازمان کامل‌تر شود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا سامانه SIEM آبالون قابلیت کار در زیرساخت‌های پراکنده و چند دیتاسنتر را دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، SIEM آبالون با پشتیبانی از تحلیل توزیع‌شده، می‌تواند داده‌ها و لاگ‌ها را از منابع مختلف در نقاط جغرافیایی متفاوت، جمع‌آوری و به‌صورت متمرکز تحلیل کند؛ بدون نیاز به تجمیع فیزیکی داده‌ها در یک محل خاص.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استفاده از خدمات تحلیل و مانیتورینگ توسط تیم متخصص آبالون وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، سازمان‌ها می‌توانند تحلیل‌های امنیتی را به تیم متخصص SOC آبالون بسپارند یا از امکانات سامانه SIEM آبالون به‌صورت مستقل بهره‌مند شوند. این انعطاف‌پذیری باعث می‌شود متناسب با نیاز و منابع سازمان، بهترین راهکار را انتخاب کنید.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  mounted() {},
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
};
